import type { TemplateAssignmentScope } from '@Application/Documents/TemplateAssignments/TemplateAssignmentScope';

// No `toJSON()`: a DELETE carries no body.
class ClearTemplateAssignment {
	constructor(
		public readonly scope: TemplateAssignmentScope,
		// The type's numeric identifier: it travels in the URL, never in a body.
		public readonly documentTypeId: number,
	) {
		Object.freeze(this);
	}
}

export default ClearTemplateAssignment;
